import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import { all_employee } from "../../../services/employeeApi";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import SharedModal from "../../../components/UiComponent/SharedContentModal";
import BasicTable from "../../../components/UiComponent/customTable";
import { GrView, GrStatusGoodSmall } from "react-icons/gr";
import AssignProjectForm from "../../Project/assignProject";
import { GetUserInfo, hasAccess } from "../../../utils/permissionChecker";
const Employee = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const user = GetUserInfo();
  const getEmployeeQuery = useQuery(["employee"], () => all_employee());
  const [showModal, setShowModal] = useState(false);
  const [laborId, setLaborId] = useState();
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const employeeData = useMemo(() => {
    const data = getEmployeeQuery.data || [];
    if (!data.length) return [];
    if (user.accessRole === "administrator") return data;
    if (user.accessRole === "manager") {
      return data.filter((emp) => emp.branch_id === user?.employee?.branch_id);
    }
    return data.filter((emp) => emp.id === user?.employee?.id);
  }, [getEmployeeQuery.data]);

  if (getEmployeeQuery.isLoading) {
    return <div>Loading...</div>;
  }

  if (getEmployeeQuery.isError) {
    return <div>Error: {getEmployeeQuery.error.message}</div>;
  }
  const handleViewEmployee = (employeeId) => {
    history.push("/employee-view", { employeeId });
  };

  const openAssignProjectModal = (event, id) => {
    event.preventDefault();
    handleShowModal();
    setLaborId(id);
  };
  const handleButtonSubmit = () => {
    handleCloseModal();
  };
  const employeeColumns = [
    {
      header: "full_name",
      accessorFn: (row) => `${row.first_name} ${row.father_name}`,
    },
    {
      header: "phone",
      accessorKey: "phone",
    },
    {
      header: "sex",
      accessorKey: "sex",
    },
    {
      header: "branch",
      accessorFn: (row) => `${row.branch?.name}`,
    },
    {
      header: "action",
      accessor: "id",
      cell: (row) => (
        <>
          <GrStatusGoodSmall
            style={{
              color: row.row.original.status !== true ? "red" : "green",
            }}
          />
          <Button
            variant="btn btn-sm m-2"
            size="sm"
            onClick={() => handleViewEmployee(row.row.original.id)}
          >
            <GrView />
          </Button>
        </>
      ),
    },
  ];
  return (
    <div>
      {hasAccess(["administrator", "manager"], user.accessRole) ? (
        <BasicTable
          data={employeeData}
          columns={employeeColumns}
          title={`employe_list`}
          actionButton={
            <Link
              to="/employee-add"
              className="btn btn-sm btn-info position-relative d-flex align-items-center justify-content-between"
            >
              {t("add_employee")}
            </Link>
          }
        />
      ) : null}
      <SharedModal
        show={showModal}
        title="select_project_and_assign"
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
        content={
          <AssignProjectForm
            onSubmitButton={handleButtonSubmit}
            parentID={laborId}
          />
        }
      />
    </div>
  );
};
export default Employee;
